export const UserRoles = [
  {
    id: 'hotelAdmin',
    name: 'Hotel Admin',
  },
];

export const UserDepartment = [
  {
    id: 'admin',
    name: 'Administration',
  },
];
